import { call, put, select } from 'redux-saga/effects';
import {
  disconnectOrganisationsFailure,
  disconnectOrganisationsSuccess,
  fetchOrganisationsRequest,
  fetchOrganisationsSuccess,
} from '../actions';
import { disconnectOrganisation } from '../api';
import { DisconnectOrganisationRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { getOrgMappings, getOrgOrganisations } from '../selectors';
import { Organisation } from '../models';
import { getAuthUser, getAuthUserLicence } from 'store/auth/selectors';
import { push } from 'store/navigation/actions';
import routes from 'routes';
import { renderErrorMessage } from 'utils/render-error-message';
import { getCurrentSubscription } from 'store/billing/selectors';
import { getCurrentSubscriptionRequest } from 'store/billing/actions';
import { EntityStatus, LicenseStatus } from 'store/app/enums';
import { removeViesInfo } from 'store/vat-checker/actions';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* disconnectOrganisationSaga(
  action: DisconnectOrganisationRequestAction
) {
  try {
    let err: ApiError | null;
    const { organisationId, fromVIES, statusType } = action.payload;
    const response: ApiResponse = yield call(
      disconnectOrganisation,
      organisationId,
      statusType
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    /* const orgs: Organisation[] = yield select(getOrgOrganisations);
    const maps = yield select(getOrgMappings);

    const idx = orgs.findIndex((o) => o.uuid === organisationId);
    if (idx > -1) {
      if (statusType === EntityStatus.DELETED) {
        orgs.splice(idx, 1);
      } else if (statusType === EntityStatus.VIEW_ONLY) {
        orgs[idx].status = EntityStatus.VIEW_ONLY;
      }
    }
 */
    //yield put(fetchOrganisationsSuccess(orgs, maps));
    yield put(fetchOrganisationsRequest());
    yield put(disconnectOrganisationsSuccess());

    const currentUser = yield select(getAuthUser);

    // Remove the deleted entity's VIES info from the Redux state
    const orgs: Organisation[] = yield select(getOrgOrganisations);
    const deletedOrg = orgs?.find((o) => o.uuid === organisationId);
    if (deletedOrg?.connectionId) {
      yield put(removeViesInfo(deletedOrg.connectionId));
    }

    const currentSubscription = yield select(getCurrentSubscription);
    if (currentUser) {
      localStorage.removeItem(`vies-infos-${currentUser.userUuid}`);
      const userLicence = yield select(getAuthUserLicence);
      if (currentSubscription && userLicence?.status === LicenseStatus.ACTIVE) {
        yield put(getCurrentSubscriptionRequest(currentUser?.accountUuid));
      }
    }

    if (!fromVIES) {
      yield put(push(routes.organisations.all));
      //delay(500);
      //window.location.reload();
    } else {
      window.location.reload();
    }

    const messageDescription =
      statusType === EntityStatus.VIEW_ONLY
        ? 'Entity changed to view-only successfully'
        : response.responseMessage.message;

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: messageDescription,
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(disconnectOrganisationsFailure());
  }
}
